import { SDSChevronIcon } from '@repo/sds/SDSChevronIcon';
import { SDSPrimitiveButton } from '@repo/sds/SDSPrimitiveButton';
import { SDSText } from '@repo/sds/SDSText';
import { getTimezoneAbbreviation, getTimezoneOffset } from '@repo/ui/utils/time/timezone';

import { useTimezone } from '../../../../hooks/use-timezone';

import './TimezoneButton.scss';

import { DataTestIds } from '@repo/frontend-shared/data-test-ids';

interface TimezoneButtonProps {
  isOpen: boolean;
  onClick: () => void;
  selectedTimezone?: string;
}

export function TimezoneButton({ isOpen, onClick, selectedTimezone }: TimezoneButtonProps) {
  const { timezone } = useTimezone();

  const timezoneText = [
    getTimezoneAbbreviation(selectedTimezone || timezone),
    getTimezoneOffset(selectedTimezone || timezone),
  ].join(' ');

  return (
    <SDSPrimitiveButton
      className="TimezoneButton"
      onClick={onClick}
      dataTestId={DataTestIds.ONBOARDING.TIMEZONE_SELECT}
    >
      <SDSText type="body-medium" text="Time Zone:" />
      <SDSText type="body-medium-bold" text={timezoneText} className="TimezoneButton__outer-timezone" />
      <SDSChevronIcon isExpanded={isOpen} />
    </SDSPrimitiveButton>
  );
}
